
import gql from "graphql-tag";

export const graphQL_shema = ()=> {

    const resetPassword = gql`
        mutation($token:String!,$input:ResetPasswordResponse!) {
            resetPassword(token:$token, input:$input) {
                status
                Message

            }
        }
    `;

    const verificationTokenPasswordResetQuery = gql`
        query ($token:String!) {
            resetPasswordTokenVerification(token:$token) {
                code
                message
            }
        }
    `;
    return({
        resetPassword,
        verificationTokenPasswordResetQuery
    })
}